import Import from '../components/FirstSteps/Import'
import ConfirmCompanyData from '../components/FirstSteps/ConfirmCompanyData'
import Liberate from '../components/FirstSteps/Liberate'

let routes = {
    path: '/firstSteps',
    component: resolve => require(['../components/layout/Basic/App'], resolve),
    children: [
        {
            path: '/firstSteps/importation',
            name: 'Importações',
            component: Import
        },
        {
            path: '/firstSteps/confirmCompanyData',
            name: 'Confirmar dados da Empresa',
            component: ConfirmCompanyData
        },
        {
            path: '/firstSteps/liberate',
            name: 'Liberar pesquisa',
            component: Liberate
        },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/firstSteps.js